__turbopack_context__.v({
  "black": "LinkButton-module-scss-module__BeEG7G__black",
  "linkButton": "LinkButton-module-scss-module__BeEG7G__linkButton",
  "white": "LinkButton-module-scss-module__BeEG7G__white",
});
